"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _reactReduxI18n = require("react-redux-i18n");

var _core = require("@material-ui/core");

var _reactDropzone = require("react-dropzone");

var _strings = require("../../utils/strings");

var _arrays = require("../../utils/arrays");

var _UploadDropzone = _interopRequireDefault(require("./UploadDropzone"));

var _upload = _interopRequireDefault(require("../../utils/upload"));

var _UploadFooterView = _interopRequireDefault(require("./UploadFooterView"));

var _UploadDocumentDetails = _interopRequireDefault(require("./UploadDocumentDetails"));

var _UploadHeaderView = _interopRequireDefault(require("./UploadHeaderView"));

var _jsxRuntime = require("react/jsx-runtime");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DOCUMENT_MAX_SIZE = _upload.default.DOCUMENT_MAX_SIZE;
var DOCUMENT_MIN_SIZE = _upload.default.DOCUMENT_MIN_SIZE;

var UploadProjectSharedDocument = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UploadProjectSharedDocument, _React$Component);

  var _super = _createSuper(UploadProjectSharedDocument);

  function UploadProjectSharedDocument(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, UploadProjectSharedDocument);
    _this = _super.call(this, props, context);
    _this.state = {
      fieldErrors: {},
      showFieldErrors: false,
      isSubmittable: false,
      file: null,
      additionalDesignation: ''
    };
    _this.validateFields = _this.validateFields.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkIfSubmittable = _this.checkIfSubmittable.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAdditionalDesignationChange = _this.handleAdditionalDesignationChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDropRejected = _this.handleDropRejected.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDrop = _this.handleDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.getFieldErrorText = _this.getFieldErrorText.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UploadProjectSharedDocument, [{
    key: "validateFields",
    value: function validateFields() {
      var fieldErrors = this.state.fieldErrors;
      var hasError = false;

      if (!this.state.file) {
        hasError = true;
      }

      var additionalDesignation = this.state.additionalDesignation;

      if (this.props.showAdditionalDesignation && ((0, _strings.isEmpty)(additionalDesignation) || additionalDesignation === false)) {
        fieldErrors.additionalDesignation = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "error.required"
        });
        hasError = true;
      }

      this.setState({
        fieldErrors: fieldErrors
      });
      return hasError;
    }
  }, {
    key: "checkIfSubmittable",
    value: function checkIfSubmittable() {
      this.setState({
        isSubmittable: !this.props.submitted && !this.validateFields()
      });
    }
  }, {
    key: "handleAdditionalDesignationChange",
    value: function handleAdditionalDesignationChange(event) {
      this.setState({
        additionalDesignation: event.target.value
      }, this.checkIfSubmittable);
    }
  }, {
    key: "handleDropRejected",
    value: function handleDropRejected(rejectedFile) {
      var fieldErrors = this.state.fieldErrors;

      switch (rejectedFile.errors[0].code) {
        case _reactDropzone.ErrorCode.FileTooLarge:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.errorMaxSizeMessage",
            count: "15"
          });
          break;

        case _reactDropzone.ErrorCode.FileTooSmall:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.errorMinSizeMessage",
            count: "1"
          });
          break;

        case _reactDropzone.ErrorCode.FileInvalidType:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.errorTypeMessage"
            }), this.props.extensions.replace(/,/g, ' | ')]
          });
          break;

        default:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "error.generic"
          });
      }

      this.setState({
        fieldErrors: fieldErrors
      });
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(acceptedFiles, rejectedFiles) {
      if (!(0, _arrays.isEmpty)(acceptedFiles)) {
        var fieldErrors = this.state.fieldErrors;
        fieldErrors.file = null;
        this.setState({
          file: acceptedFiles[0],
          fieldErrors: fieldErrors
        }, this.checkIfSubmittable);
      } else if (!(0, _arrays.isEmpty)(rejectedFiles)) {
        this.handleDropRejected(rejectedFiles[0]);
      }
    }
  }, {
    key: "getFieldErrorText",
    value: function getFieldErrorText(fieldName) {
      if (this.state.fieldErrors === null || typeof this.state.fieldErrors[fieldName] === 'undefined' || !this.state.showFieldErrors && fieldName !== 'file') {
        return null;
      }

      return this.state.fieldErrors[fieldName];
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();
      this.checkIfSubmittable();

      if (!this.state.isSubmittable) {
        this.setState({
          showFieldErrors: true
        });
        return;
      }

      var info = {
        additionalDesignation: this.state.additionalDesignation.trim()
      };
      this.props.onHandleSubmitFile(this.state.file, info);
    }
  }, {
    key: "getFileMessage",
    value: function getFileMessage() {
      return this.state.fieldErrors && this.state.fieldErrors.file ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "error",
        id: "error-file-message",
        children: this.getFieldErrorText('file')
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var errorFileMessage = this.getFileMessage();
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        onSubmit: this.handleSubmit,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "col-12",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadHeaderView.default, {
            documentName: _reactReduxI18n.I18n.t('banette.uploadNewDocument')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Collapse, {
            in: !this.state.file,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadDropzone.default, {
                file: this.state.file,
                extensions: this.props.extensions,
                onDrop: this.handleDrop,
                maxSize: DOCUMENT_MAX_SIZE,
                minSize: DOCUMENT_MIN_SIZE,
                errorFileMessage: errorFileMessage
              })
            })
          }), this.state.file && /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Fade, {
            in: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadDocumentDetails.default, {
                file: this.state.file,
                onRemoveFile: function onRemoveFile() {
                  return _this2.setState({
                    file: null
                  });
                }
              }), this.props.showAdditionalDesignation && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
                  label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                      value: "banette.documentName"
                    }), " *"]
                  }),
                  id: "additionalDesignation",
                  name: "additionalDesignation",
                  error: Boolean(this.getFieldErrorText('additionalDesignation')),
                  helperText: this.getFieldErrorText('additionalDesignation'),
                  value: this.state.additionalDesignation,
                  onChange: this.handleAdditionalDesignationChange,
                  autoComplete: "off",
                  InputProps: {
                    inputProps: {
                      maxLength: this.props.maxDocumentNameLength
                    }
                  }
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                  value: "message.textCounter",
                  counter: this.state.additionalDesignation ? this.state.additionalDesignation.length : 0,
                  maxLength: this.props.maxDocumentNameLength
                })]
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadFooterView.default, {
            submitted: this.props.submitted,
            isSubmittable: this.state.isSubmittable,
            onCancelClick: this.props.onCancel
          })]
        })
      });
    }
  }]);
  return UploadProjectSharedDocument;
}(_react.default.Component);

UploadProjectSharedDocument.defaultProps = {
  extensions: '.pdf,.docx',
  maxDocumentNameLength: 50
};
UploadProjectSharedDocument.propTypes = {
  onCancel: _propTypes.default.func.isRequired,
  onHandleSubmitFile: _propTypes.default.func.isRequired,
  submitted: _propTypes.default.bool.isRequired,
  extensions: _propTypes.default.string,
  maxDocumentNameLength: _propTypes.default.number,
  showAdditionalDesignation: _propTypes.default.bool.isRequired
};
var _default = UploadProjectSharedDocument;
exports.default = _default;
//# sourceMappingURL=UploadProjectSharedDocument.js.map